import { ImageType } from '@nx-frontend/shared/types/image-selector';

export interface Image {
  type: ImageType;
  value: string;
}

export function generateImage(image: Image): string {
  return `${image.type}#${image.value}`;
}

export function parseImage(value: string): Image {
  const parts = value.split('#');
  if (parts.length > 2 || (parts.length === 1 && parts[0] === '')) {
    throw new Error('invalid image value');
  }

  if (parts.length === 1) {
    return {
      type: ImageType.URL,
      value: parts[0],
    };
  }

  const imageType = parts[0];
  const imageValue = parts[1];
  if (!(Object.values(ImageType) as string[]).includes(imageType)) {
    throw new Error('invalid image type');
  }

  return {
    type: imageType as ImageType,
    value: imageValue,
  };
}
